<template>
  <div class="confirm-block">
    <div class="confirm-block__image">
      <svg width="7" height="37" viewBox="0 0 7 37" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.95898 26.1611H2.39551L1.15039 0.306641H6.2041L4.95898 26.1611ZM0.710938 33.4121C0.710938 31.1986 1.6875 30.0918 3.64062 30.0918C4.58464 30.0918 5.30892 30.3766 5.81348 30.9463C6.33431 31.516 6.59473 32.3379 6.59473 33.4121C6.59473 34.4538 6.33431 35.2676 5.81348 35.8535C5.29264 36.4232 4.56836 36.708 3.64062 36.708C2.79427 36.708 2.0944 36.4557 1.54102 35.9512C0.98763 35.4303 0.710938 34.584 0.710938 33.4121Z" fill="white"/>
      </svg>
    </div>
    <h3 class="confirm-block__title">Войдите или зарегистрируйтесь</h3>
    <p class="confirm-block__text">
      Чтобы смотреть историю заказов и узнавать
      об актуальных акциях и предложениях —
      войдите в систему
    </p>

    <div class="confirm-block__row">
      <t-button type="blue uppercase confirm-block__signin" :callback="onSingIn">Войти</t-button>
      <div class="confirm-block__reg" @click="onSingUp">Зарегистрироваться</div>
    </div>

    <div class="right-menu__link">
      <span @click="onGuest">Заказать без регистрации</span>
    </div>
  </div>
</template>

<script>
import Button from '@components/ui/button.vue';
import { mapMutations } from 'vuex';
export default {
  components: {
    't-button': Button,
  },
  methods: {
    ...mapMutations('params', [
      'toogleSingup',
      'toogleSingin',
      'toggleNotSingIn',
      'toggleRightMenu',
    ]),
    onSingUp: function() {
      this.toogleSingup();
      this.toggleNotSingIn();
    },
    onSingIn: function() {
      this.toogleSingin();
      this.toggleNotSingIn();
    },
    onGuest: function() {
      this.toggleNotSingIn();
      this.toggleRightMenu();
      this.$router.push('/order');
    },
  },
};
</script>

<style lang="sass" scoped>
.confirm-block
  &__image
    width: 92px
    height: 92px
    border-radius: 50%
    background-color: #BFC9D8
    display: flex
    align-items: center
    justify-content: center
    margin-bottom: 24px
    svg
      width: 41px
      height: 31px
      fill: none

  &__title
    font-size: 32px
    line-height: 35px
    margin-bottom: 24px

  &__text
    font-size: 14px
    line-height: 130%
    margin-bottom: 32px
    font-weight: 500

  &__guest
    display: block

  &__row
    display: flex
    align-items: center

  &__reg
    margin-left: 32px
    line-height: 110%
    font-weight: 500
    cursor: pointer

  &__signin
    padding: 0 32px
    height: 50px

  @media screen and ( max-width: 1279px)
    &__image
      margin-top: 16px

    &__title
      font-size: 28px
      line-height: 110%

    &__row
      flex-direction: column

    &__reg
      margin: 24px 0 0
      font-size: 14px

    &__signin
      height: 42px
      width: 100%
      display: flex
      justify-content: center
      span
          font-size: 14px

    .right-menu__link
      margin: 100px auto 0
      width: fit-content
      span
        font-size: 14px

</style>



// WEBPACK FOOTER //
// src/templates/components/right-menu/ui/notSingIn.vue